// Copyright (c) 2021 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getTypeInfo ( type ) {

    const endPoint = `${basePath}/reallocation-seq/type/${type}`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function getReallocationSeqRetInd () {

    return getTypeInfo( 'RETAIL_IND' );

}

export async function getReallocationSeqBuildWeek () {

    return getTypeInfo( 'BUILD_WEEK' );

}

export async function getReallocationSeqSpecialAcct () {

    return getTypeInfo( 'SPECIAL_ACCT' );

}

export async function getReallocationSeqUnitCode () {

    return getTypeInfo( 'UNIT_CODE' );

}

export async function getFamilyWeek () {

    const endPoint = `${basePath}/get-familyweeknum`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function postFamilyWeeks ( payload ) {

    const endPoint = `${basePath}/reallocation-familyupdate`;
    const payLoad = {
        familydetails: payload
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function postSortingSequence ( payload ) {

    const endPoint = `${basePath}/reallocation-update`;
    // const payLoad = {
    //     familydetails: payload
    // };

    const options = {
        body: JSON.stringify( payload ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
